// extracted by mini-css-extract-plugin
export default {"container":"ProductDetailsWidget_container__0nt0H","searchInput":"ProductDetailsWidget_searchInput__xUz8s","sectionsContainer":"ProductDetailsWidget_sectionsContainer__HjhNJ"};